module.exports = __webpack_public_path__ + "b6551397a6838ae8866d4852900abf47.svg";